import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { trialDemo, contactInfo } from '../utils/mockData';

export const TrialDemoPromo = () => {
  const handleWhatsApp = (type) => {
    const messages = {
      form: 'Halo, saya ingin mengikuti Trial Demo 1 Bulan Dreams Marketing.',
      consult: 'Halo, saya ingin konsultasi tentang Trial Demo.'
    };
    const url = `https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(messages[type])}`;
    window.open(url, '_blank');
  };

  const scrollToForm = () => {
    const element = document.getElementById('trial-demo-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="trial-demo" className="py-20 scroll-mt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <Card className="border-2 border-[#D32F2F] bg-white dark:bg-[#0F0F0F] shadow-2xl">
          <CardContent className="p-8 lg:p-12">
            <div className="max-w-4xl mx-auto space-y-8">
              <div className="text-center space-y-4">
                <Badge className="bg-[#D32F2F] text-white hover:bg-[#B71C1C] px-4 py-1">
                  Penawaran Spesial
                </Badge>
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white">
                  {trialDemo.title}
                </h2>
                <p className="text-lg text-gray-600 dark:text-gray-400">
                  {trialDemo.subtitle}
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-8">
                {/* Benefits */}
                <div className="space-y-4">
                  <h4 className="font-semibold text-gray-900 dark:text-white text-lg">Keuntungan Trial:</h4>
                  {trialDemo.benefits.map((benefit, index) => (
                    <div key={index} className="flex items-start space-x-3">
                      <CheckCircle2 className="w-6 h-6 text-[#D32F2F] flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700 dark:text-gray-300">{benefit}</span>
                    </div>
                  ))}
                </div>

                {/* Terms */}
                <div className="space-y-4">
                  <h4 className="font-semibold text-gray-900 dark:text-white text-lg">Ketentuan Trial:</h4>
                  {trialDemo.terms.map((term, index) => (
                    <div key={index} className="flex items-start space-x-3">
                      <div className="w-6 h-6 rounded-full bg-[#D32F2F]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <span className="text-[#D32F2F] font-semibold text-sm">{index + 1}</span>
                      </div>
                      <span className="text-gray-700 dark:text-gray-300">{term}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 pt-6">
                <Button
                  onClick={scrollToForm}
                  className="bg-[#D32F2F] hover:bg-[#B71C1C] text-white px-8 py-6 text-lg flex-1"
                >
                  Isi Formulir & Mulai Trial Demo 1 Bulan
                </Button>
                <Button
                  onClick={() => handleWhatsApp('consult')}
                  variant="outline"
                  className="border-[#D32F2F] text-[#D32F2F] hover:bg-[#D32F2F] hover:text-white px-8 py-6 text-lg"
                >
                  Konsultasi via WhatsApp
                </Button>
              </div>

              <p className="text-sm text-gray-500 dark:text-gray-500 text-center italic">
                Dengan mengisi formulir, Anda menyetujui skema Trial Demo 1 Bulan.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
